import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export var getUserBankByOrganizationAlias = function getUserBankByOrganizationAlias(userBanks, alias) {
  return userBanks.find(function (item) {
    return item.organization && item.organization.alias === alias;
  });
};
export var getUserBankByOrganizationId = function getUserBankByOrganizationId(userBanks, id) {
  return userBanks.find(function (item) {
    return item.organization && item.organization.id === id;
  });
};